export default __webpack_public_path__ + "static/media/Head_2_Ear_3_C2.6edda05d.svg";